import { useContext, useEffect, useState } from "react";
import { CoreFieldProps } from "../Fields/types/fieldTypes";
import { SkeletonComponent } from "@syncfusion/ej2-react-notifications";
import { FormDisabledContext, FormFieldPropsContext } from "./FieldForm";
import systemFieldConfig, { FieldConfig } from "./FieldConfig";

export interface FieldProps {
  fieldProps: string | Partial<CoreFieldProps>;
  handleOnBlur?: any;
  customFieldConfig?: FieldConfig;
}

export function FieldComponent(props: FieldProps) {
  const formIsDisabled = useContext(FormDisabledContext);
  const formFieldsData = useContext(FormFieldPropsContext);

  const [ready, setReady] = useState(false);
  const [fieldProps, setFieldProps] = useState<Partial<CoreFieldProps>>();

  useEffect(() => {
    updateFieldProps();
  }, [formIsDisabled, formFieldsData, props.fieldProps]);

  useEffect(() => {
    setupFields();
  }, []);

  const updateFieldProps = () => {
    // Update fieldprops
    if (props.fieldProps === undefined) {
      throw new Error("FieldProps is required, but not provided");
    }

    if (formFieldsData && typeof props.fieldProps === "string") {
      const fieldProps = formFieldsData.find(
        (field) => field.fieldName === props.fieldProps
      );
      if (fieldProps) {
        const modFieldProps = {
          ...fieldProps,
          ...{
            disabled: formIsDisabled || fieldProps.disabled,
          },
        };

        setFieldProps(modFieldProps);
      }
    } else if (typeof props.fieldProps !== "string") {
      const modFieldProps = {
        ...props.fieldProps,
        ...{
          disabled: formIsDisabled || props.fieldProps.disabled,
        },
      };

      setFieldProps(modFieldProps);
    }
  };

  const setupFields = () => {
    setReady(true);
  };

  return (
    <>
      {!ready && <SkeletonComponent height="15px"></SkeletonComponent>}
      {ready && fieldProps && fieldProps.hidden && <></>}
      {ready && fieldProps && !fieldProps.hidden && (
        <div
          className={`base-field${
            fieldProps.className ? ` base-field-${fieldProps.className}` : ""
          }`}
          onBlur={props.handleOnBlur}
        >
          {(function () {
            if (!fieldProps.type) {
              throw new Error(
                `Field type is not defined in schema, but is required.`
              );
            }
            const fieldConfig = props.customFieldConfig || systemFieldConfig;
            const FieldComponent = fieldConfig[fieldProps.type] as React.FC<
              Partial<CoreFieldProps>
            >;

            if (!FieldComponent) {
              throw new Error(
                `Field type ${fieldProps.type} is not defined in FieldConfig`
              );
            }

            return <FieldComponent {...fieldProps} />;
          })()}
        </div>
      )}
    </>
  );
}

export const Field = FieldComponent;
export default Field;
